import PaymentHighlightWrapper from './components/PaymentHighlightWrapper';
export default PaymentHighlightWrapper;